<ng-container>
    <form ngForm="loginForm" #loginForm="ngForm">
        <div class="row login_pannel">
            <div class="col-lg-3 col-md-4 col-sm-6 col-8 " style="height:205px">
                <div class="card shadow p-25" style="height:280px">
                    <h2 class="text-center mb-30 font-25">Login</h2>
                    <fn-input class="border-0 mb-15" [(ngModel)]="loginUser.username" [fnInputValidator]
                         [dataKey]="'username'" [parentForm]="loginForm"
                        name="Username">
                    </fn-input>
                    <fn-input class="border-0  mb-15" [(ngModel)]="loginUser.password" [fnInputValidator]
                         [dataKey]="'password'" [parentForm]="loginForm"
                        name="Password">
                    </fn-input>
                    <fn-button [type]="'success'" btnType="button"  [contentClass]="'w-100'" [btnClass]="'btn-block width-100'"
                        [text]="'Login'" (click)="onSubmit(loginForm)">
                    </fn-button>
                </div>
            </div>
        </div>
    </form>
</ng-container>